import React, { useState } from 'react'
import { postInsertUnaFormaFarmaceuticaYViasAplicacion } from '../../../services/ApiSuministros'
import ModalViasAplicacion from './ModalViasAplicacion'
import ModalErrorFormasFarmaceuticas from './ModalErrorFormasFarmaceuticas'

const ModalCrearFormasFarmaceuticas = ({setmodalOnCrearFormasFarmaceuticas, setactualizarData}) => {
    const [errorCodigo, seterrorCodigo]=useState('Seleccionar código')
    const [errorDescripcion, seterrorDescripcion]=useState('Seleccionar descripción')
    const [errorViaAplicacion, seterrorViaAplicacion]=useState('')
    const [modalOnViasAplicacion , setmodalOnViasAplicacion]=useState(false)
    const [modalOnErrorFormasFarmaceuticas, setmodalOnErrorFormasFarmaceuticas]=useState(false)
    const [mensajeError, setmensajeError]=useState('')
    const [loading, setloading]=useState(true)
    const [dataUnaViaAplicacion, setdataUnaViaAplicacion]=useState({
      'ViAplCod':'',
      'ViAplDSc':'',
      'ViAplOrd':'',
      'ViAplSex':''
    })
    const [dataAgregarViasAplicacion, setdataAgregarViasAplicacion]=useState([])

    const handleCancelarClick=()=>{
        setmodalOnCrearFormasFarmaceuticas(false)
    }

    const handleOnsubmitInsertFormasFarmaceuticas=(e)=>{
        e.preventDefault()
        const insertar={
            'FrmCod': e.target.codigo.value,
            'FrmDsc': e.target.descripcion.value,
            'ViAplCods': dataAgregarViasAplicacion
        }
        if(errorCodigo === '' && errorDescripcion === ''){
          setloading(false)
          postInsertUnaFormaFarmaceuticaYViasAplicacion(insertar).then((res)=>{
            setloading(true)
            if(res.data.success){
              setactualizarData(insertar)              
              setmodalOnCrearFormasFarmaceuticas(false)
            }else{
              setmensajeError(res.data.message)
              setmodalOnErrorFormasFarmaceuticas(true)
            }
            
          })
        }
    }

    const handleChangeDescripcion=(e)=>{
      if(e.target.value.trim()){
        seterrorDescripcion('')
      }else{
        seterrorDescripcion('Seleccionar descripción')
      }
    }

    const handleChangeCodigo=(e)=>{
      if(e.target.value.trim()){
        seterrorCodigo('')
      }else{
        seterrorCodigo('Seleccionar código')
      }
    }

    const handleFocusCodigoVia=()=>{
      setmodalOnViasAplicacion(true)
    }

    const passDataViaAplicacion=(item)=>{
      setmodalOnViasAplicacion(false)
      setdataUnaViaAplicacion({
        'ViAplCod': item.ViAplCod,
        'ViAplDSc': item.ViAplDSc,
        'ViAplOrd': item.ViAplOrd,
        'ViAplSex': item.ViAplSex
      })
      seterrorViaAplicacion('')
    }

    const handleClickAgregarViaAplicacion=()=>{
      if(dataUnaViaAplicacion.ViAplCod){
        const existe = dataAgregarViasAplicacion.some((via) => via.ViAplCod === dataUnaViaAplicacion.ViAplCod);
        if (!existe) {
        setdataAgregarViasAplicacion((prevData) => [
          ...prevData,  // Copia el estado anterior
          dataUnaViaAplicacion      // Agrega el nuevo elemento
        ]);

        setdataUnaViaAplicacion({
          'ViAplCod': '',
          'ViAplDSc': '',
          'ViAplOrd': '',
          'ViAplSex': ''
        })
      } else {
        seterrorViaAplicacion('El registro ya existe')
      }
      }
    }

    const handleClickEliminarViaAplicacion=(idVia)=>{
      setdataAgregarViasAplicacion((prevData) => 
        prevData.filter(via => via.ViAplCod !== idVia)  // Devuelve todos los elementos excepto el que tiene el id que queremos eliminar
      );
    }
  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%-3rem)] max-w-5xl  mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">        
    <h5
      className="text-xl font-medium leading-normal text-white"
      id="exampleModalScrollableLabel"
    >
     Crear Formas Farmaceuticas
    </h5>  
          <button
            type="button"
            onClick={handleCancelarClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
        <div className="flex-auto overflow-y-auto relative">
        <form onSubmit={handleOnsubmitInsertFormasFarmaceuticas}>
          <div className="flex-auto overflow-y-auto relative p-1">
              <div className="flex">                
                <div className="w-full  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Código Forma
                  </label>
                  <input
                    onChange={(e) => {
                      // Capturamos el valor actual del input
                      let inputValue = e.target.value;

                      // Si el valor supera los 2 caracteres, lo truncamos a los primeros 2
                      if (inputValue.length > 2) {
                        e.target.value = inputValue.slice(0, 2);
                      }

                      // Puedes manejar el valor en tu función handleChangeCodigo
                      handleChangeCodigo(e);
                    }}
                    name="codigo"
                    autoComplete="off"
                    type="number"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal text-gray-900 bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    id="exampleFormControlInput1"
                    placeholder=""
                  />

                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                  {errorCodigo}
                  </label>
                </div>
                
                
              </div>
              <div className="flex">
              
                <div className="w-full  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Descripción Forma
                  </label>
                  <input
                    onChange={(e) => {
                      // Capturamos el valor actual del input
                      let inputValue = e.target.value;

                      // Si el valor supera los 50 caracteres, lo truncamos
                      if (inputValue.length > 50) {
                        e.target.value = inputValue.slice(0, 50);
                      }

                      // Llamamos a la función handleChangeDescripcion con el valor actualizado
                      handleChangeDescripcion(e);
                    }}
                    name="descripcion"
                    autoComplete="off"
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal text-gray-900 bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    id="exampleFormControlInput1"
                    placeholder=""
                  />

                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorDescripcion}
                  </label>
                </div>
              </div> 
              <div className="flex  text-left">
                
                <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Código Vía
                  </label>
                  
                  <input
                    onFocus={handleFocusCodigoVia}
                    defaultValue={dataUnaViaAplicacion.ViAplCod}
                    name='codigoVia'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    readOnly
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorViaAplicacion}
                  </label>
                  </div>
                  <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Descripción Vía
                  </label>
                  <div className='flex'>
                  <input
                    defaultValue={dataUnaViaAplicacion.ViAplDSc}
                    disabled={true}
                    name='descripcionVia'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  <button
                    onClick={handleClickAgregarViaAplicacion}
                    type="button"
                    className="mx-2 inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight whitespace-nowrap rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Agregar Vía
                  </button>

                     </div>
                  </div>
              </div>
              <div className="flex flex-col">
          <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
            <div className="py-2 inline-block min-w-full">
              <div className="overflow-auto md:overflow-visible">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                      <th></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900  py-2 bg-gray-200"
                      >          
                                    
                      </th>         
                      
                                
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Eliminar 
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Descripción 
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Orden 
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Sexo Aplicación 
                      </th>
                             
                    </tr>
                  </thead>
                  <tbody >
                    {
                      dataAgregarViasAplicacion.map((item, index)=>(
                        <tr className=" divide-y divide-slate-700 " key={index}>
                            <td></td>
                            <td></td>
                            <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                                
                                <button
                                        onClick={()=>handleClickEliminarViaAplicacion(item.ViAplCod)}
                                        type="button"
                                        className="inline-block px-2 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out"
                                    >
                                        Eliminar
                                    </button>
                            </td>
                            <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left"> 
                                {item.ViAplDSc}
                            </td>
                            <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                                {item.ViAplOrd}
                            </td>
                            <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"> 
                                {item.ViAplSex === 'A'? 'Ambos':null}
                                {item.ViAplSex === 'F'? 'Femenino':null}
                                {item.ViAplSex === 'M'? 'Masculino':null}
                            </td>
                        </tr>
                    ))
                    }
                    
                 
                   </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
          </div>
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
          <button
            type="button"
            onClick={handleCancelarClick}
            className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
          <button type="submit"
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Aceptar
          </button>
        </div>
        </form>
        </div>
      </div>
    </div>    
    {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            } 
    {modalOnViasAplicacion? <ModalViasAplicacion setmodalOnViasAplicacion={setmodalOnViasAplicacion} passDataViaAplicacion={passDataViaAplicacion}/>:null}
    {modalOnErrorFormasFarmaceuticas? <ModalErrorFormasFarmaceuticas setmodalOnErrorFormasFarmaceuticas={setmodalOnErrorFormasFarmaceuticas} mensajeError={mensajeError}/>:null}
  </div>
  )
}

export default ModalCrearFormasFarmaceuticas